import { Grid, Button, Typography, Fab } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, Suspense } from "react";
import BillView from "../Components/BillView/BillView";
import CollageJourneyMapSection from "../Components/CartSections/CollageJourneyMapSection/CollageJourneyMapSection";
import PrintsSection from "../Components/CartSections/PrintsSection/PrintsSection";
import FooterNote from "../Components/FoooterNote/FooterNote";
import Footer from "../Components/Footer/Footer";
import Header from "../Components/Header/Header";
import HeaderNote from "../Components/HeaderNote/HeaderNote";
import SummarySection from "../Components/SummarySection/SummarySection";
import SectionTitle2 from "../Components/Ui-Components/SectionTitle2/SectionTitle2";
import ColorHelper from "../Helpers/ColorHelper";
import { useSelector } from "react-redux";
import { useState } from "react";
import { clearCart, getCartDetails, saveUser } from "../redux/shoppingActions";
import { useDispatch } from "react-redux";
import EmptyCart from "../Components/CartSections/EmptyCart/EmptyCart";
import { useLocation, useNavigate } from "react-router-dom";
import VideoDownloadSection from "../Components/CartSections/VideoSection/VideoDownloadSection";
import FilledButton from "../Components/Ui-Components/Buttons/FilledButton/FilledButton";
import FontHelper from "../Helpers/FontHelper";
import { ApiManager } from "../ApiClient";
import axios from "axios";
import { KeyboardArrowUp, KeyboardArrowDown } from "@mui/icons-material";


import SponsorDiscountModal from "../Components/Modals/SponsorDiscount/SponsorDiscountModal";
// import DigitalDownloadsSection from "../Components/CartSections/DigitalDownloadsSection/DigitalDownloadsSection";
const DigitalDownloadsSection = React.lazy(() =>
  import(
    "../Components/CartSections/DigitalDownloadsSection/DigitalDownloadsSection"
  )
);


const CartPage = () => {
  const dispatch = useDispatch();
  const productInfo = useSelector((state) => state.shop.products);
  // console.log("productInfo", productInfo);
  const cartInfo = useSelector((state) => state.shop.cartInfo);
  const cartDetails = useSelector((state) => state.shop.cartDetails);
  const { sponsorOfferAvailableFlag } = useSelector((state) => state.shop.products);
  const [isLoading, setIsLoading] = useState(false);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [showScrollButtons, setShowScrollButtons] = useState(false);
  const [isNearBottom, setIsNearBottom] = useState(false);
  const itemsPerPage = 50; // Per page pagination threshold
  const actionsRef = React.useRef(null);

  const downloadsCart = cartInfo.filter((item) => {
    if (item.type == "download") {
      return item.category === "image";
    }
  });
  const printsCart = cartInfo.filter((item) => item.type == "print");
  const collageCart = cartInfo.filter((item) => item.type.includes("collage"));
  const videoCart = cartInfo.filter((item) => item.category == "video");
  const config = useSelector((state) => state.config.masterConfig.result);
  const packageDetail = useSelector((state) => state.shop.packageDetails);
  let isPending = localStorage?.getItem("isPending");
  const { discountedPhoto } = useSelector(
    (state) => state.shop.sponsorDiscount
  );
  const userIsdCode = useSelector((state) => state.user.isdCode);

  const cartPrice = useSelector((state) => state.shop.cartCheckout);
  const navigate = useNavigate();

  const updateBill = (updatedCart) => { };

  const location = useLocation();
  const findPath = location.pathname;

  // Pagination logic for downloads
  const getPaginatedDownloads = () => {
    if (!downloadsCart || downloadsCart.length === 0) return [];
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return downloadsCart.slice(startIndex, endIndex);
  };

  const getTotalPages = () => {
    if (!downloadsCart) return 0;
    return Math.ceil(downloadsCart.length / itemsPerPage);
  };

  const handleNextPage = () => {
    if (currentPage < getTotalPages()) {
      setCurrentPage(currentPage + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const getVisiblePages = () => {
    const totalPages = getTotalPages();
    const maxPagesToShow = 5;

    // If total pages is 7 or less, show all pages
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    let startPage, endPage;

    // Calculate the range based on current page position
    if (currentPage <= 3) {
      startPage = 1;
      endPage = 5;
    } else if (currentPage >= totalPages - 2) {
      startPage = totalPages - 4;
      endPage = totalPages;
    } else {
      startPage = currentPage - 2;
      endPage = currentPage + 2;
    }

    return Array.from(
      { length: endPage - startPage + 1 },
      (_, i) => startPage + i
    );
  };

  const renderPaginationButtons = () => {
    const totalPages = getTotalPages();
    const visiblePages = getVisiblePages();

    // If 7 or fewer pages, show all without ellipsis
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNumber) => (
        <Button
          key={pageNumber}
          onClick={() => handlePageClick(pageNumber)}
          sx={{
            fontFamily: FontHelper.fBold,
            fontSize: { xs: 9, md: 12 },
            minWidth: { xs: 28, md: 45 },
            height: { xs: 28, md: 40 },
            backgroundColor: currentPage === pageNumber ? "#3f0e77" : "#FFFFFF",
            color: currentPage === pageNumber ? ColorHelper.WhiteColor : ColorHelper.BlackColor,
            border: currentPage === pageNumber ? `2px solid #3f0e77` : "2px solid #E0E0E0",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: currentPage === pageNumber ? "bold" : "normal",
            padding: { xs: "2px", md: "8px" },
            flexShrink: 0,
            "&:hover": {
              backgroundColor: currentPage === pageNumber ? "#3f0e77" : "#F0F0F0",
              borderColor: currentPage === pageNumber ? "#3f0e77" : "#D0D0D0",
            },
          }}
        >
          {pageNumber}
        </Button>
      ));
    }

    const buttons = [];
    const firstPage = visiblePages[0];
    const lastPage = visiblePages[visiblePages.length - 1];

    // Show first page if not in visible range
    if (firstPage > 1) {
      buttons.push(
        <Button
          key={1}
          onClick={() => handlePageClick(1)}
          sx={{
            fontFamily: FontHelper.fBold,
            fontSize: { xs: 9, md: 12 },
            minWidth: { xs: 28, md: 45 },
            height: { xs: 28, md: 40 },
            backgroundColor: "#FFFFFF",
            color: ColorHelper.BlackColor,
            border: "2px solid #E0E0E0",
            borderRadius: "6px",
            cursor: "pointer",
            padding: { xs: "2px", md: "8px" },
            flexShrink: 0,
            "&:hover": { backgroundColor: "#F0F0F0" },
          }}
        >
          1
        </Button>
      );
      if (firstPage > 2) {
        buttons.push(
          <Typography key="start-ellipsis" sx={{ fontFamily: FontHelper.fBold, fontSize: { xs: 12, md: 14 }, flexShrink: 0 }}>
            ...
          </Typography>
        );
      }
    }

    // Show visible pages
    visiblePages.forEach((pageNumber) => {
      buttons.push(
        <Button
          key={pageNumber}
          onClick={() => handlePageClick(pageNumber)}
          sx={{
            fontFamily: FontHelper.fBold,
            fontSize: { xs: 10, md: 12 },
            minWidth: { xs: 35, md: 45 },
            height: { xs: 35, md: 40 },
            backgroundColor: currentPage === pageNumber ? "#3f0e77" : "#FFFFFF",
            color: currentPage === pageNumber ? ColorHelper.WhiteColor : ColorHelper.BlackColor,
            border: currentPage === pageNumber ? `2px solid #3f0e77` : "2px solid #E0E0E0",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: currentPage === pageNumber ? "bold" : "normal",
            padding: { xs: "4px", md: "8px" },
            flexShrink: 0,
            "&:hover": {
              backgroundColor: currentPage === pageNumber ? "#3f0e77" : "#F0F0F0",
              borderColor: currentPage === pageNumber ? "#3f0e77" : "#D0D0D0",
            },
          }}
        >
          {pageNumber}
        </Button>
      );
    });

    // Show last page if not in visible range
    if (lastPage < totalPages) {
      if (lastPage < totalPages - 1) {
        buttons.push(
          <Typography key="end-ellipsis" sx={{ fontFamily: FontHelper.fBold, fontSize: { xs: 12, md: 14 }, flexShrink: 0 }}>
            ...
          </Typography>
        );
      }
      buttons.push(
        <Button
          key={totalPages}
          onClick={() => handlePageClick(totalPages)}
          sx={{
            fontFamily: FontHelper.fBold,
            fontSize: { xs: 10, md: 12 },
            minWidth: { xs: 35, md: 45 },
            height: { xs: 35, md: 40 },
            backgroundColor: "#FFFFFF",
            color: ColorHelper.BlackColor,
            border: "2px solid #E0E0E0",
            borderRadius: "6px",
            cursor: "pointer",
            padding: { xs: "4px", md: "8px" },
            flexShrink: 0,
            "&:hover": { backgroundColor: "#F0F0F0" },
          }}
        >
          {totalPages}
        </Button>
      );
    }

    return buttons;
  };

  const scrollToActions = () => {
    if (actionsRef.current) {
      actionsRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  useEffect(() => {
    findPath === "/cart" && localStorage.setItem("currPage", "Cart");
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercentage = (scrollTop / docHeight) * 100;

      setShowScrollButtons(scrollTop > 300);
      setIsNearBottom(scrollPercentage > 70);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    let updatedCartInfo = [];
    // console.log("packageDetail",packageDetail)
    if (packageDetail === "b" && cartPrice.bibNumber != "selfiesearch") {
      updatedCartInfo = [
        {
          id: "b_ultraprem",
          image: productInfo?.photo.length,
          type: "download",
          category: "pack",
          bibNumber: cartPrice.bibNumber,
          price: productInfo?.ultra_premium_pack,
        },
        ...videoCart,
        ...printsCart,
        ...collageCart
      ];
    } else if (packageDetail === "a" && cartPrice.bibNumber != "selfiesearch") {
      updatedCartInfo = [
        {
          id: "b_premium",
          image: productInfo?.photo.length,
          type: "download",
          category: "pack",
          bibNumber: cartPrice.bibNumber,
          price: productInfo?.bundlePriceInfo?.price,
        },
        ...videoCart,
        ...printsCart,
        ...collageCart
      ];
    }
    const UserId = localStorage.getItem("ID");
    const payload = {
      ...cartDetails,
      sponsorofferID:
        discountedPhoto.length > 0 ? cartPrice.getSponsorOffersDetails.id : "",
      userID: UserId || "",
      cartInfo:
        (packageDetail === "b" || packageDetail === "a") &&
          downloadsCart?.length >= productInfo.threshold_photo_count
          ? updatedCartInfo
          : cartInfo,
    };
    if (location.state?.isPending !== false) {
      setIsLoading(true);
      dispatch(getCartDetails(payload)).then(() => {
        localStorage.setItem("cartPrice ", JSON.stringify(cartPrice))
        setTimeout(() => {
          setIsLoading(false);
        }, 50);
      });
    }
    localStorage.setItem("currPage", "Cart");
  }, [cartInfo, discountedPhoto]);

  useEffect(() => {
    window.scrollTo(0, 0);
    const userId = localStorage.getItem("ID");
    if (userId) {
      axios
        .post(ApiManager.checkoutUserInfo(), {
          userID: localStorage.getItem("ID"),
        })
        .then((response) => {
          dispatch(saveUser(response.data.result))
        })
        .catch((err) => { });
    }
  }, []);


  return (
    <Box>
      <Header />
      <div style={{ display: isLoading ? "flex" : "none" }} className="modal">
        <div className="modal-content">
          <div className="loader"></div>
          <div className="modal-text">Processing...</div>
        </div>
      </div>
      {cartInfo.length > 0 ? (
        <>
          <SectionTitle2
            title={cartPrice.eventName}
            eventLogo={cartPrice.eventLogo}
            eventLogoShow={true}
            bgColor={ColorHelper.WhiteColo4}
          />
          <HeaderNote priceInfo={cartPrice.priceInfo} />
          <SponsorDiscountModal sponsorOfferAvailableFlag={sponsorOfferAvailableFlag} />

          <SummarySection
            bibNumber={cartDetails.bibNumber}
            unlabledPage="true"
          />
          <Grid
            container
            sx={{
              backgroundColor: ColorHelper.WhiteColor2,
              pb: 12,
              px: { xs: 4, md: 5, lg: 10 },
            }}
          >
            {new Date().getTime() >
              new Date(localStorage?.getItem("awsImageExpiry")).getTime() &&
              isPending !== "true" ? (
              <Box
                sx={{
                  border: "1px solid #F5EAEA",
                  borderRadius: "10px",
                  px: "20px",
                  py: "50px",
                  display: "grid",
                  placeItems: "center",
                  my: "50px",
                  fontWeight: "bold",
                  alignSelf: "center",
                }}
              >
                <span style={{}}>
                  Oops !!..Your search session is expired please serach again
                  get the valid images
                </span>
                <FilledButton
                  handleClick={() => {
                    localStorage?.removeItem("awsImageExpiry");
                    navigate("/home");
                    dispatch(clearCart());
                  }}
                  btnText={"Go back"}
                  color={ColorHelper.PrimaryColor}
                  bgColor={ColorHelper.WhiteColor}
                  bordercolor={ColorHelper.WhiteColor}
                  sx={{
                    position: "relative",
                    fontFamily: FontHelper.fSemiBold,
                    fontWeight: 500,
                    fontSize: { xs: 12, md: 16 },
                    height: { xs: "40px", sm: "50px" },
                    px: "19px",
                    fontWeight: 600,
                    my: "20px",
                  }}
                  cstHover={{
                    "&:hover": {
                      backgroundColor: ColorHelper.PrimaryColorLight,
                      color: ColorHelper.WhiteColor,
                    },
                  }}
                />
              </Box>
            ) : (
              <>
                <Grid item xs={12} md={8}>
                  <Suspense fallback={() => { }}>
                    <DigitalDownloadsSection
                      data={downloadsCart.length > 50 ? getPaginatedDownloads() : downloadsCart}
                      updateBill={updateBill}
                      digital="digital"
                      orderId={cartDetails.orderId}
                      SponsorDiscountModal={SponsorDiscountModal}
                    />
                  </Suspense>

                  {videoCart?.length > 0 && (
                    <VideoDownloadSection
                      data={videoCart}
                      updateBill={updateBill}
                      video="video"
                      orderId={cartDetails.orderId}
                    />
                  )}
                  {!config.DISABLEPRINTS.includes(cartPrice.eventId) && userIsdCode === '+91' && (
                    <PrintsSection
                      data={printsCart}
                      print="print"
                      updateBill={updateBill}
                      orderId={cartDetails.orderId}
                      bibNumber={cartDetails.bibNumber}
                    />
                  )}
                  {collageCart.length > 0 &&
                    !JSON.parse(
                      localStorage.getItem("Config")
                    ).DISABLEPRINTS.includes(cartPrice.eventId) && (
                      <CollageJourneyMapSection
                        collageCart={collageCart}
                        collage="collage"
                        orderId={cartDetails.orderId}
                        bibNumber={cartDetails.bibNumber}
                      />
                    )}

                  {/* Pagination Controls for Cart Downloads */}
                  {downloadsCart.length > 50 && (
                    <Box
                      ref={actionsRef}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: { xs: 0.2, md: 2 },
                        mt: 6,
                        mb: 4,
                        flexWrap: "nowrap",
                        backgroundColor: "#F5F5F5",
                        padding: { xs: "8px 4px", md: "20px" },
                        borderRadius: "8px",
                        overflowX: { xs: "auto", md: "visible" },
                        overflowY: "hidden",
                      }}
                    >
                      <Button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                        sx={{
                          fontFamily: FontHelper.fBold,
                          fontSize: { xs: 9, md: 13 },
                          minWidth: "auto",
                          backgroundColor: currentPage === 1 ? "#D4D4D4" : "#3f0e77",
                          color: currentPage === 1 ? "#999999" : ColorHelper.WhiteColor,
                          px: { xs: 2, md: 2.5 },
                          py: { xs: 0.5, md: 1.2 },
                          height: { xs: 28, md: 40 },
                          borderRadius: "6px",
                          whiteSpace: "nowrap",
                          flexShrink: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Box sx={{ display: { xs: "none", md: "block" } }}>← Previous</Box>
                        <Box sx={{ display: { xs: "block", md: "none" } }}>←</Box>
                      </Button>

                      <Box sx={{
                        display: "flex",
                        gap: { xs: 0.2, md: 0.8 },
                        mx: { xs: 0.6, md: 0 },
                        flexWrap: "nowrap",
                      }}>
                        {currentPage > 1 && (
                          <>
                            <Button
                              onClick={() => handlePageClick(1)}
                              sx={{
                                fontFamily: FontHelper.fBold,
                                fontSize: { xs: 10, md: 12 },
                                minWidth: { xs: 35, md: 45 },
                                height: { xs: 35, md: 40 },
                                backgroundColor: "#FFFFFF",
                                color: ColorHelper.BlackColor,
                                border: `2px solid #E0E0E0`,
                                borderRadius: "6px",
                                cursor: "pointer",
                                padding: { xs: "4px", md: "8px" },
                                "&:hover": {
                                  backgroundColor: "#F0F0F0",
                                },
                              }}
                            >
                              1
                            </Button>
                            {currentPage > 3 && (
                              <Typography sx={{ fontFamily: FontHelper.fBold, fontSize: { xs: 12, md: 14 } }}>
                                ...
                              </Typography>
                            )}
                          </>
                        )}

                        {getVisiblePages()
                          .filter((pageNumber) => !(currentPage > 1 && pageNumber === 1))
                          .map((pageNumber) => (
                            <Button
                              key={pageNumber}
                              onClick={() => handlePageClick(pageNumber)}
                              sx={{
                                fontFamily: FontHelper.fBold,
                                fontSize: { xs: 10, md: 12 },
                                minWidth: { xs: 35, md: 45 },
                                height: { xs: 35, md: 40 },
                                backgroundColor:
                                  currentPage === pageNumber ? "#3f0e77" : "#FFFFFF",
                                color:
                                  currentPage === pageNumber
                                    ? ColorHelper.WhiteColor
                                    : ColorHelper.BlackColor,
                                border:
                                  currentPage === pageNumber
                                    ? `2px solid #3f0e77`
                                    : "2px solid #E0E0E0",
                                borderRadius: "6px",
                                cursor: "pointer",
                                fontWeight: currentPage === pageNumber ? "bold" : "normal",
                                padding: { xs: "4px", md: "8px" },
                                "&:hover": {
                                  backgroundColor:
                                    currentPage === pageNumber ? "#3f0e77" : "#F0F0F0",
                                  borderColor:
                                    currentPage === pageNumber ? "#3f0e77" : "#D0D0D0",
                                },
                              }}
                            >
                              {pageNumber}
                            </Button>
                          ))}

                        {currentPage < getTotalPages() - 1 && (
                          <>
                            {currentPage < getTotalPages() - 2 && (
                              <Typography sx={{ fontFamily: FontHelper.fBold, fontSize: { xs: 12, md: 14 } }}>
                                ...
                              </Typography>
                            )}
                            <Button
                              onClick={() => handlePageClick(getTotalPages())}
                              sx={{
                                fontFamily: FontHelper.fBold,
                                fontSize: { xs: 10, md: 12 },
                                minWidth: { xs: 35, md: 45 },
                                height: { xs: 35, md: 40 },
                                backgroundColor: "#FFFFFF",
                                color: ColorHelper.BlackColor,
                                border: "2px solid #E0E0E0",
                                borderRadius: "6px",
                                cursor: "pointer",
                                padding: { xs: "4px", md: "8px" },
                                "&:hover": {
                                  backgroundColor: "#F0F0F0",
                                },
                              }}
                            >
                              {getTotalPages()}
                            </Button>
                          </>
                        )}
                      </Box>

                      <Button
                        onClick={handleNextPage}
                        disabled={currentPage === getTotalPages()}
                        sx={{
                          fontFamily: FontHelper.fBold,
                          fontSize: { xs: 9, md: 13 },
                          minWidth: "auto",
                          backgroundColor:
                            currentPage === getTotalPages() ? "#D4D4D4" : "#3f0e77",
                          color:
                            currentPage === getTotalPages() ? "#999999" : ColorHelper.WhiteColor,
                          px: { xs: 2, md: 2.5 },
                          py: { xs: 0.5, md: 1.2 },
                          height: { xs: 28, md: 40 },
                          borderRadius: "6px",
                          whiteSpace: "nowrap",
                          flexShrink: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Box sx={{ display: { xs: "none", md: "block" } }}>Next →</Box>
                        <Box sx={{ display: { xs: "block", md: "none" } }}>→</Box>
                      </Button>
                    </Box>
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  sx={{
                    pt: 3,
                    position: "relative",
                    width: { xs: "100%", md: "auto" },
                    backgroundColor: "transparent",
                    px: { xs: 2, md: 0 },
                  }}
                >
                  {cartPrice !== undefined ? (
                    <BillView
                      cartInfo={cartInfo}
                      bibnumber={productInfo.bibNumber}
                    />
                  ) : null}
                </Grid>
              </>
            )}
          </Grid>
        </>
      ) : (
        <EmptyCart />
      )}

      {/* Animated Back to Top / Go to Pagination Button */}
      {showScrollButtons && (
        <Fab
          onClick={isNearBottom ? scrollToTop : scrollToActions}
          sx={{
            position: "fixed",
            bottom: { xs: 16, md: 16 },
            right: { xs: 8, md: 12 },
            backgroundColor: "#3f0e77",
            color: ColorHelper.WhiteColor,
            zIndex: 1000,
            transition: "all 0.3s ease",
            "@keyframes spinUp": {
              "0%": { transform: "translateY(10px) rotate(0deg)", opacity: 0 },
              "100%": { transform: "translateY(0px) rotate(0deg)", opacity: 1 },
            },
            "@keyframes slideDown": {
              "0%": { transform: "translateY(-10px) rotate(0deg)", opacity: 0 },
              "100%": { transform: "translateY(0px) rotate(0deg)", opacity: 1 },
            },
            animation: isNearBottom ? "spinUp 0.5s ease-out" : "slideDown 0.5s ease-out",
            "&:hover": {
              backgroundColor: "#2d0a56",
              transform: "scale(1.1)",
            },
            "& svg": {
              animation: isNearBottom
                ? "keyframes { from { transform: translateY(0); } to { transform: translateY(-4px); } } 2s ease-in-out infinite"
                : "keyframes { from { transform: translateY(0); } to { transform: translateY(4px); } } 2s ease-in-out infinite",
            }
          }}
          aria-label={isNearBottom ? "back to top" : "go to actions"}
          title={isNearBottom ? "Back to Top" : "Go to Checkout"}
        >
          {isNearBottom ? (
            <KeyboardArrowUp size="small" sx={{ fontSize: { xs: 28, md: 32 } }} />
          ) : (
            <KeyboardArrowDown size="small" sx={{ fontSize: { xs: 28, md: 32 } }} />
          )}
        </Fab>
      )}

      <FooterNote />
      <Footer />
    </Box>
  );
};
export default CartPage;
